// extracted by mini-css-extract-plugin
export default {"addButton":"priceBlock_addButton__iDGHx","attrList":"priceBlock_attrList__-m9lr"};